import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useYear } from './YearContext';
import { MenuItem } from '@mui/material';
import { format, isValid } from 'date-fns'
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GetParam from '../api/GetParam';

const YearPicker = () => {
    const { getYear } = require("date-fns");
    const { selectedYear, setSelectedYear } = useYear();
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate()
    const location = useLocation()
    const dateRange = GetParam('dateRange', location)

    useEffect(() => {
        // if selectedyear and url daterange are the same return
        if(selectedYear[0].dateString === dateRange) {
            return;
        } 
        // Check if url years are valid if yes then set the new selected year
        else {
            try {
                const dates = dateRange.split('..')
                const date1Valid = isValid(new Date(dates[0]))
                const date2Valid = isValid(new Date(dates[1]))
                if(date1Valid) {
                    if(date2Valid) {
                        const newDateString = dates[0] + '..' + dates[1]
                        setSelectedYear([
                            {
                                startDate: dates[0],
                                endDate: dates[1],
                                key: 'selection',
                                dateString: newDateString,
                                currentYear: getYear(new Date(dates[0]))
                            }
                        ])
                    } else {
                        // date2 invalid
                        return;
                    }
                } else {
                    // date1 invalid
                    return;
                }
            } catch (e) {
                console.log(e)
            }
        }
    },[dateRange, getYear, selectedYear, setSelectedYear])

    const getYearOptions = () => {
        const pastYears = Array.from({ length: 10 }, (_, index) => currentYear - index);
        const futureYears = Array.from({ length: 2 }, (_, index) => currentYear + index + 1);
        return [...pastYears, ...futureYears].sort((a, b) => a - b);
    };

    const HandleClick = (e) => {
        const startOfYear = new Date(e.target.value, 0, 1);
        const endOfYear = new Date(e.target.value, 11, 31);
        setSelectedYear([
            {
                startDate: startOfYear,
                endDate: endOfYear,
                key: "selection",
                dateString: `${format(startOfYear, 'yyyy-MM-dd') + '..' + format(endOfYear, 'yyyy-MM-dd')}`,
                currentYear: e.target.value
            }
        ]);
        navigate(location.pathname + '?dateRange=' + format(startOfYear, 'yyyy-MM-dd') + '..' + format(endOfYear, 'yyyy-MM-dd'))
    }

    return (
        <FormControl sx={{ width: '250px', textAlign:'center' }}>
            <Select
                aria-label='yearselector'
                value={selectedYear[0].currentYear}
                onChange={(e) => HandleClick(e)}
                sx={{ width: '100%', height: '30px', color:'gray' }} // Adjust the height as needed
                inputProps={{ style: { textAlign: 'center' } }}
            >
                {getYearOptions().map((year) => (
                    <MenuItem key={year} value={year}>
                        {year}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
export default YearPicker;
